/**
 * ProcessContentDescriptionUseCase
 *
 * Processes a content description to extract hashtags and mentions.
 * Matches Flutter's _processContentDescription in set_content_description_screen.dart.
 */

import type { ContentTagEntity } from '@/domain/entities/contentTag/contentTagEntity';
import { processContentHashTags } from '@/domain/utils/hashtagsParser';
import { extractMentions } from '@/domain/utils/mentionsParser';

export interface ProcessContentDescriptionResult {
  processedDescription: string;
  hashTags: string[];
  hashTagsObjects: ContentTagEntity[];
  mentions: string[];
}

export class ProcessContentDescriptionUseCase {
  execute(description: string): ProcessContentDescriptionResult {
    if (!description) {
      return {
        processedDescription: '',
        hashTags: [],
        hashTagsObjects: [],
        mentions: [],
      };
    }

    const { processedDescription, hashTags, hashTagsObjects } = processContentHashTags(description);
    const mentions = extractMentions(processedDescription);

    return {
      processedDescription,
      hashTags,
      hashTagsObjects,
      mentions,
    };
  }
}

export const createProcessContentDescriptionUseCase = () => new ProcessContentDescriptionUseCase();
